function setFormValidationForErrorMessage({ input, state }) {
  if (input.result.errors) {
    state.set('client.forms.validation', {
      valid: false,
      section: input.result.errors[0].path
    })
  }
}

export default setFormValidationForErrorMessage



// WEBPACK FOOTER //
// ./src/modules/user/actions/setFormValidationForErrorMessage.js